import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;

const getCachedData = (key) => {
  const cachedData = localStorage.getItem(key);
  return cachedData ? JSON.parse(cachedData) : null;
};

const setCachedData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

const clearCachedData = (key) => {
  localStorage.removeItem(key);
};

// export const testDispatch=()=>{
//   const dispatch=useDispatch();
//       dispatch(setDropdownOptions({ dropdownType: 'drpPrioritiesOptions', options: [{key:'one',value:1}] }));
               
// }

// Function to fetch data with caching
const fetchDataWithCache = async (url, cacheKey, headers = {}, bypassCache = false) => {
  try {
    // If bypassCache is true, clear localStorage cache
    if (bypassCache) {
      clearCachedData(cacheKey);
    }

    // Attempt to retrieve cached data from localStorage
    const cachedData = getCachedData(cacheKey);

    if (cachedData && !bypassCache) {
      // Return cached data if available and not bypassing cache
      return { data: cachedData };
    } else {
      // Fetch data from the API if no cached data or cache is being cleared
      const response = await axios.get(url, { headers });

      const data = response.data;
      // Save the fetched data to localStorage
      setCachedData(cacheKey, data);

      return response;
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    throw error;
  }
};

// Modify functions to use caching

export const getDrpPriorities = async (bypassCache = false) => {
  const url = `${API}/drpdowns/getDrpPriorities`;
  const cacheKey = 'drpPrioritiesOptions';
  return fetchDataWithCache(url, cacheKey, {}, bypassCache);
};

export const getDrpCompanies = async (token, bypassCache = false) => {
  const url = `${API}/drpdowns/getDrpCompanies`;
  const cacheKey = 'drpCompaniesOptions';
  const headers = {
    "authorization": `Bearer ${token}`,
  };
  return fetchDataWithCache(url, cacheKey, headers, bypassCache);
};

export const getDrpAssetCategories = async (bypassCache = false) => {
  const url = `${API}/drpdowns/getDrpAssetCategories`;
  const cacheKey = 'drpAssetCategoriesOptions';
  return fetchDataWithCache(url, cacheKey, {}, bypassCache);
};

export const getDrpAssets = async (bypassCache = false) => {
  const url = `${API}/drpdowns/getDrpAssets`;
  const cacheKey = 'drpAssetsOptions';
  return fetchDataWithCache(url, cacheKey, {}, bypassCache);
};

export const getTicketAssignedUsers = async (token, bypassCache = false) => {
  const url = `${API}/drpdowns/getTicketAssignedUsers`;
  const cacheKey = 'ticketAssignedUsersOptions';
  const headers = {
    "authorization": `Bearer ${token}`,
  };
  return fetchDataWithCache(url, cacheKey, headers, bypassCache);
};

export const getDrpContactTypes = async (token, bypassCache = false) => {
  const url = `${API}/drpdowns/getDrpContactTypes`;
  const cacheKey = 'drpContactTypesOptions';
  const headers = {
    "authorization": `Bearer ${token}`,
  };
  return fetchDataWithCache(url, cacheKey, headers, bypassCache);
};








  export const getDrpCustomers = async () =>
  await axios.get(
    `${API}/drpdowns/getDrpCustomers`,
    {
      headers: {
        // authtoken,
      },
    },
  );

  export const getDrpAgents = async () =>
  await axios.get(
    `${API}/drpdowns/getDrpAgents`,
    {
      headers: {
        // authtoken,
      },
    },
  );



  export const getDrpCauseOfIssues = async () =>
  await axios.get(
    `${API}/drpdowns/getDrpCauseOfIssues`,
    {
      headers: {
        // authtoken,
      },
    },
  );


  export const getDrpTicketStatus = async () =>
  await axios.get(
    `${API}/drpdowns/getDrpTicketStatus`,
    {
      headers: {
        // authtoken,
      },
    },
  );

  export const getDrpTicketChargingTypes = async () =>
  await axios.get(
    `${API}/drpdowns/getDrpTicketChargingType`,
    {
      headers: {
        // authtoken,
      },
    },
  );


  export const getDrpCountries = async (token) =>
  await axios.get(
    `${API}/drpdowns/getDrpCountries`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );

  export const getDrpUserRoles = async (token) =>
  await axios.get(
    `${API}/drpdowns/getDrpRoles`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );

  export const getDrpAssignedCompanies = async (token) =>
  await axios.get(
    `${API}/drpdowns/getDrpAssignedCompanies`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );

  export const getDrpTicketListCompanies = async (token) =>
  await axios.get(
    `${API}/drpdowns/getDrpTicketListCompanies`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );

  export const getDrpInformedByUsers = async (token,companyId) =>
  await axios.get(
    `${API}/drpdowns/getDrpInformedByUsers/${companyId}`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );



  

  export const getDrpResolutionStatus = async (token) =>
  await axios.get(
    `${API}/drpdowns/getDrpResolutionStatus`,
    {
      headers: {
        "authorization":`Bearer ${token}`
      },
    },
  );

  

// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {

//     if (error.response.status === 401) {
//       // Handle Unauthorized error here
//       console.log('auth Unauthorized', error.response);
//       localStorage.removeItem('token');
//     } else {
//       // Handle other errors here

//       console.log('Error:', error.message);
//     }
//     return Promise.reject(error);
//   },
// );



// const CACHE_KEY = 'drpPrioritiesOptions';
  
// // Function to get dropdown priorities with caching
// export const getDrpPriorities = async (bypassCache = false) => {
//   try {
//     // If bypassCache is true, clear localStorage cache
//     if (bypassCache) {
//       localStorage.removeItem(CACHE_KEY);
//     }

//     // Attempt to retrieve cached data from localStorage
//     const cachedOptions = localStorage.getItem(CACHE_KEY);

//     if (cachedOptions && !bypassCache) {
//       // Return cached data if available and not bypassing cache
//       return { data: JSON.parse(cachedOptions) };
//     } else {
//       // Fetch data from the API if no cached data or cache is being cleared
//       const response = await axios.get(`${API}/drpdowns/getDrpPriorities`, {
//         headers: {
//           // authtoken,
//         },
//       });

//       const data = response.data;
//       // Save the fetched data to localStorage
//       localStorage.setItem(CACHE_KEY, JSON.stringify(data));

//       return response;
//     }
//   } catch (error) {
//     console.error('Error fetching dropdown priorities:', error);
//     throw error;
//   }
// };


  // export const getDrpPriorities = async () =>
  // await axios.get(
  //   `${API}/drpdowns/getDrpPriorities`,
  //   {
  //     headers: {
  //       // authtoken,
  //     },
  //   },
  // );


  
// // Function to get dropdown priorities with caching
// export const getDrpPriorities = async (bypassCache = false) => {
//   try {
//     const CACHE_KEY='drpPrioritiesOptions';
//     if (bypassCache) {
//       localStorage.removeItem(CACHE_KEY);
//     }
//     const cachedOptions = localStorage.getItem(CACHE_KEY);

//     if (cachedOptions && !bypassCache) {
//       return { data: JSON.parse(cachedOptions) };
//     } else {
//       const response = await axios.get(`${API}/drpdowns/getDrpPriorities`, {
//         headers: {
//           // authtoken,
//         },
//       });

//       const data = response.data;
//       localStorage.setItem(CACHE_KEY, JSON.stringify(data));

//       return response;
//     }
//   } catch (error) {
//     console.error('Error fetching dropdown priorities:', error);
//     throw error;
//   }
// };




// export const getDrpCompanies = async (token) =>
//   await axios.get(
//     `${API}/drpdowns/getDrpCompanies`,
//     {
//       headers: {
//         "authorization":`Bearer ${token}`
//       },
//     },
//   );




// export const getDrpAssetCategories = async () =>{
//  return await axios.get(
//     `${API}/drpdowns/getDrpAssetCategories`,
//     {
//       headers: {
//         // authtoken,
//       },
//     },
//   );

// }


//   export const getDrpAssets = async () =>
//   await axios.get(
//     `${API}/drpdowns/getDrpAssets`,
//     {
//       headers: {
//         // authtoken,
//       },
//     },
//   );

//   export const getTicketAssignedUsers = async (token) =>
//     await axios.get(
//       `${API}/drpdowns/getTicketAssignedUsers`,
//       {
//         headers: {
//           "authorization":`Bearer ${token}`
//         },
//       },
//     );

//   export const getDrpContactTypes = async (token) =>
//   await axios.get(
//     `${API}/drpdowns/getDrpContactTypes`,
//     {
//       headers: {
//         "authorization":`Bearer ${token}`
//       },
//     },
//   );

